import { createContext } from "react";

export const PermissionsContext = createContext({
  canView: true,
  canEdit: true,
  canShare: true,
  isAdmin: true,
  role: "admin",
  permissionsLoading: false
});
